import React from "react"
import {FieldAutomationConditionFormProps} from "../../../render/automation-condition-form";
import PropTypes from "prop-types";



export default class FieldProto_AutomationConditionForm extends React.Component<FieldAutomationConditionFormProps> {

    // static propTypes = {
    //     field           : PropTypes.object,
    //     config          : PropTypes.object,
    //
    //     // options         : PropTypes.array,
    //
    //     onChangeCallback: PropTypes.func,
    // }

    onChangeFieldValues = (fieldValues: any) => {
        this.props.onChangeCallback({fieldValues})
    }

    render() {

        // options = field.getOptions

        return <div className="ui5-txt-default ui5-txt-red">{this.props.field.type}.automationConditionForm</div>
    }
}

// export default function FieldProto_AutomationConditionForm(props: FieldAutomationConditionFormProps) {
//
//     // const value = _.get(props.model, props.field.fieldId, null)
//
//     return (
//         <div className="ui5-txt-default ui5-txt-red">{props.field.type}.automationConditionForm</div>
//     )
//
// }